var _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStatusPingDot = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4334,
    cy: 21,
    rx: 21.6834,
    ry: 21,
    fill: "current",
    fillOpacity: 0.21
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4341,
    cy: 20.9998,
    rx: 16.0269,
    ry: 15.5217,
    fill: "current",
    fillOpacity: 0.21
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.434,
    cy: 21.0006,
    rx: 8.48481,
    ry: 8.21739,
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStatusPingDot, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/statusPingDot.7ede9f60.svg";
export { ForwardRef as ReactComponent };